import { NgModule } from '@angular/core';

import { ModelosComponent } from './modelos.component';
import {SharedModule} from "../../shared/shared.module";
import {ModeloApiService} from "./shared/modelo-api.service";
import {ModeloNavigationService} from "./shared/modelo-navigation.service";
import {ModeloService} from "./shared/modelo.service";
import {ModeloFormComponent} from "./modelo-form/modelo-form.component";
import {ModeloListComponent} from "./modelo-list/modelo-list.component";
import {ModelosRoutingModule} from "./modelos-routing.module";

@NgModule({
  imports: [
    SharedModule,
    ModelosRoutingModule
  ],
  providers: [
    ModeloApiService,
    ModeloNavigationService,
    ModeloService
  ],
  declarations: [
    ModelosComponent,
    ModeloFormComponent,
    ModeloListComponent
  ],
  exports: [
    ModeloListComponent
  ]
})
export class ModelosModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/modelos/modelos.module.ts
 **/